/**
 * @module components\ghInput\imageInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";
import { API_BASE_URL } from '@/utils/conf';

@Component
export default class ImageInput extends InputBase {

  private get source() {
    let source = API_BASE_URL + this.prop.source;
    if (this.value) {
      return source + "/" + this.value;
    }
    return undefined;
  }
}
